import { useDataQuery } from "hooks/useData";
import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export const useTexts = (commonPrefix = "") => {
  const [searchParams] = useSearchParams();
  const mode = String(searchParams.get("text_debug")).replace(/[^0-9]/gi, "");
  const textData = useDataQuery(`texts/`);
  const textDict = textData && typeof textData === "object" ? textData : {};

  const getText = (key: string, defaultValue?: string) => {
    const fullKey = commonPrefix ? `${commonPrefix}_${key}` : key;

    if (mode === "1") return fullKey;
    if (mode === "2")
      return `${fullKey} → ${textDict[fullKey]} OR ${defaultValue}`;

    return textDict[fullKey] || defaultValue || fullKey;
  };

  const txt = useCallback(
    (key: string, defaultValue?: string) => getText(key, defaultValue),
    [textDict, commonPrefix],
  );

  return {
    txt,
  };
};
